<template>
  <responsive-modal
    v-model="visible"
    size="lg"
    title="Integração Conta Azul"
    link="https://ca.contaazul.com"
    description="Conheça a Conta Azul"
  >
    <div class="d-flex align-items-end gap-3">
      <bp-input
        v-model="callbackUrl"
        disabled
        class="flex-fill"
        label="URL de Redirecionamento Blitzpay"
      />
      <bp-button
        class="mb-1"
        icon="fa-regular fa-arrow-up-right-from-square"
        @click="copyCallback"
      />
    </div>
    <div class="functional-2 text-neutral-500 mb-3">
      Copie a URL acima e cole no campo de URI de Redirecionamento da Conta Azul
    </div>

    <bp-select
      v-model="form.product_id"
      label="Nome do produto"
      placeholder="Selecionar produto"
      :disabled="!!form.id"
      :options="products.map(({ id, name }) => ({ id, name }))"
    />

    <bp-input
      class="mt-5"
      v-model="form.ca_product_code"
      required
      label="Código do produto na plataforma"
      placeholder="Digite o código do produto"
      :errors="errors.ca_product_code"
    />

    <bp-input
      class="mt-5"
      v-model="form.client_id"
      required
      label="Id do cliente"
      placeholder="Digite o id do cliente"
      :errors="errors.client_id"
    />

    <bp-input
      class="mt-5"
      v-model="form.client_secret"
      required
      label="Chave secreta do cliente"
      placeholder="Digite a chave secreta do cliente"
      :errors="errors.client_secret"
    />

    <footer-actions
      class="mt-7"
      :loading="loading"
      :disabled="!isValid"
      @submit="submit"
      @cancel="visible = false"
    />
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import { mapState } from "vuex";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields([
        "id",
        "product_id",
        "status",
        "client_id",
        "client_secret"
      ]),
      loading: false,
      visible: false,

      callbackUrl:
        "https://api.blitzpay.com.br/v1/integrations/conta-azul/callback"
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      }
    },
    integrationToEdit(v) {
      this.form = {
        ...v
      };
    }
  },
  computed: {
    ...mapState("product", ["products"]),
    isValid() {
      return (
        this.form.product_id &&
        this.form.client_id &&
        this.form.client_secret &&
        this.form.ca_product_code
      );
    }
  },
  methods: {
    copyCallback() {
      navigator.clipboard.writeText(this.callbackUrl);
      this.$message.success("URL copiada!");
    },

    clear() {
      this.form = {};
      this.$emit("clear-edit");
    },
    onSubmit() {
      this.visible = false;
      this.$emit("refresh");
      this.clear();
    },
    submit() {
      this.loading = true;

      const data = {
        ...this.form
      };
      let action = "integration/postIntegration";

      if (this.integrationToEdit) {
        data.id = this.integrationToEdit.id;
        action = "integration/putIntegration";
      }

      this.$store
        .dispatch(action, data)
        .then(() => {
          this.onSubmit();
          this.$message.success("A integração foi salva!");
        })
        .catch(e =>
          this.handleErrors(
            e,
            "TRANSLATE_FIELD_INTEGRATION_MAP",
            "Erro ao salvar integração"
          )
        )
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
